(function () {
    'use strict';

    angular
        .module('app')
        .factory('breadCrumbService', breadCrumbService);

    breadCrumbService.$inject = ['$http'];

    function breadCrumbService($http) {
        var service = {
            category: "",
            details: "",
        };

        return service;

        function getData() { }
    }
})();